import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Footer from './components/Footer';
import Home from './components/Home';
import Privacy from './components/pages/Privacy';
import Register from './components/pages/Register';
import ThankYou from './components/pages/ThankYou';
import PreCheck from './components/pages/PreCheck';
import Retreat from './components/pages/Retreat';
import RetreatQs from './components/pages/RetreatQs';
import HomeV2 from './components/HomeV2';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="privacy-policy" element={<Privacy />}/>
          <Route path="register" element={<Register />} />
          <Route path="thank-you" element={<ThankYou />} />
          <Route path="pre-check" element={<PreCheck />} />
          <Route path="retreat" element={<Retreat />} />
          <Route path="retreat-interest" element={<RetreatQs />} />
          {/* <Route path='v2' element={<HomeV2 />} /> */}
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
